//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import moment from 'moment-timezone';

import { IShopTagsMetricsState } from '@instagram-account/instagram-account-shop-tags-metrics/models/AppState';
import {
  SHOP_TAGS_METRICS_ACTIONS,
  SHOP_TAGS_TREND_VALUES,
} from '@instagram-account/instagram-account-shop-tags-metrics/shop-tags-metrics-constants';
import {
  UnifiedMetricsSortDirection,
  UnifiedMetricsSortKey,
} from '@models/MetricsGatewayApiModels';

const initialState: IShopTagsMetricsState = {
  totalProductCount: 0,
  sourceType: 'IG_SHOPPING',
  dateRange: {
    alias: 'last7Days',
    startDate: moment().startOf('day').subtract(6, 'd').toDate(),
    endDate: moment().startOf('day').toDate(),
  },
  isOnboarded: false,
  isFetchingOnboardingState: true,
  isFetchingAggregateStats: true,
  isFetchingTrendStats: true,

  aggregateStats: null,

  trendStats: [],
  trendSelectedValue: SHOP_TAGS_TREND_VALUES.TOTAL_VISITS,

  shopTagsStats: null,

  shopTagsStatsOffset: 0,
  shopTagsStatsLimit: 10,
  shopTagsStatsSortKey: UnifiedMetricsSortKey.ExternalClicks,
  shopTagsStatsSortDir: UnifiedMetricsSortDirection.desc,

  totalTagCount: null,

  exportUrl: null,
  exportRequestModel: null,
  exportFilename: null,
};

export function ShopTagsMetricsReducer(state = initialState, action) {
  switch (action.type) {
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_AGGREGATE_STATS:
      return {
        ...state,
        aggregateStats: action.payload.aggregateStats,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_TREND_STATS:
      return {
        ...state,
        trendStats: action.payload.trendStats,
      };
    case SHOP_TAGS_METRICS_ACTIONS.CHANGE_TRENDS_SELECTED_VALUE:
      return {
        ...state,
        trendSelectedValue: action.payload.trendSelectedValue,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_TAG_STATS:
      return {
        ...state,
        shopTagsStats: action.payload.shopTagsStats,
      };
    case SHOP_TAGS_METRICS_ACTIONS.CHANGE_SHOP_TAGS_TABLE_PARAMS:
      return {
        ...state,
        shopTagsStatsOffset: action.payload.offset,
        shopTagsStatsLimit: action.payload.limit,
        shopTagsStatsSortKey: action.payload.sortKey,
        shopTagsStatsSortDir: action.payload.sortDirection,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_TAG_COUNT:
      return {
        ...state,
        totalTagCount: action.payload.totalTagCount,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_EXPORT_URL:
      return {
        ...state,
        exportUrl: action.payload.exportUrl,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_EXPORT_REQUEST_MODEL:
      return {
        ...state,
        exportRequestModel: action.payload.model,
      };
    case SHOP_TAGS_METRICS_ACTIONS.SET_SOURCE_TYPE:
      return {
        ...state,
        sourceType: action.payload.sourceType,
      };
    case SHOP_TAGS_METRICS_ACTIONS.RECEIVE_EXPORT_FILENAME:
      return {
        ...state,
        exportFilename: action.payload.exportFilename,
      };
    case SHOP_TAGS_METRICS_ACTIONS.CHANGE_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload.newDateRange,
      };
    default:
      return state;
  }
}
